import React from 'react'
import { FlyingStartWrapper, HighLightBox, NumberListButton, Content, HighLightSection } from './FlyingStart.style'

const FlyingStart = () => {
  return (
    <FlyingStartWrapper>
      <h1>Getting off to a flying start with us</h1>
      <p>Begin your wealth building and financial freedom journey with us in minutes</p>
      <HighLightSection>

      <HighLightBox>
        <NumberListButton>
              <div className="count-line">01</div>
        </NumberListButton>
        <Content>
          <h3>Create savings plan PIN (SP PIN)</h3>
          <p>You create your SP PIN with a KYC form and this represents your savings plan account</p>

        </Content>

      </HighLightBox>
      <HighLightBox>
        <NumberListButton>
          <div className="count-line">02</div>
              
        </NumberListButton>
        <Content>
          <h3>Create an account</h3>
          <p>Sign up for an account with your name, Email and phone number </p>

        </Content>

      </HighLightBox>
      <HighLightBox>
        <NumberListButton>
              <div>03</div>
        </NumberListButton>
        <Content>
          <h3>Affix a payment system</h3>
          <p>Your bank account is required for withdrawals and with your SP PIN and debit card, you activate and make payments into your savings and investment plans</p>
          <p>No more hassles in savings and making well meaning investment, our plans are simple but yet so intriguing, watch your money build up and work for you everyday.</p>

        </Content>

      </HighLightBox>
      </HighLightSection>
    </FlyingStartWrapper>
  )
}

export default FlyingStart